/**
 * Duplicate the content of the ticker for seamless scrolling.
 *
 * @param {*} content
 * @return {void}
 */
const duplicateScrollerContent = (content) => {
  Array.from(content).forEach((element) => {
    const tickerScrollWidth = element.offsetWidth;

    const duplicatesNeeded = Math.ceil(1250 / tickerScrollWidth) * 2;

    for (let i = 1; i < duplicatesNeeded; i++) {
      const clone = element.cloneNode(true);
      element.parentNode.appendChild(clone);
    }
  });
};

/**
 * Set the CSS for the scrolling animation of the ticker.
 *
 * @param {*} content
 * @return {void}
 */
const setScrollerAnimationCSS = (content) => {
  Array.from(content).forEach((element) => {
    const tickerScrollWidth = element.offsetWidth;
    const animationDuration = tickerScrollWidth / 100;
    const direction = document.dir;

    element.style.animationDuration = `${animationDuration}s`;
    element.style.animationName =
      direction === 'rtl' ? 'animation-marquee--rtl' : 'animation-marquee';
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const tickerContent = document.getElementsByClassName(
    'wp-block-lana-breaking-news-ticker__posts__items',
  );

  if (tickerContent.length) {
    // Duplicate the ticker content enough times to repeat seamlessly
    duplicateScrollerContent(tickerContent);

    // Calculate and set the animation duration based on content width
    setScrollerAnimationCSS(tickerContent);
  }
});
